export default __webpack_public_path__ + "static/media/Metrics.79923a76.png";